import { CenterAligned } from "@opensea/ui-kit"
import Image from "next/image"
import React from "react"
import type { ChainIdentifier } from "@/hooks/useChains/types"
import { getEquallySizedChainLogo } from "@/lib/helpers/chainUtils"
import { PLACEHOLDER_IMAGE, SIZE_TO_PX } from "./constants"
import { containedMediaClassNames } from "./styles"
import type { Size } from "./types"

type ChainMediaProps = {
  chain: ChainIdentifier
  size?: Size
}

export function ChainMedia({ chain, size = "md" }: ChainMediaProps) {
  const ChainLogo = getEquallySizedChainLogo(chain)

  const sizePx = SIZE_TO_PX[size]

  if (!ChainLogo) {
    return (
      <Image alt="" height={sizePx} src={PLACEHOLDER_IMAGE} width={sizePx} />
    )
  }

  return (
    <CenterAligned
      className={containedMediaClassNames}
      style={{ width: sizePx, height: sizePx }}
    >
      <ChainLogo />
    </CenterAligned>
  )
}
